import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../redux/ApplicationState";
import { DiseaseTypeDispatchTypes, IcdCodeTypeDispatchTypes, ReAuthIcdCodeDispatchTypes } from "../models/dispatchTypes/ICD10";
import { DiseaseTypeActionDispatchTypes, IcdCodeTypeActionDispatchTypes, ReAuthIcdCodeActionDispatchTypes } from "../constants/ICD10";
import { diseaseTypeRespValues, GetIcdCodeForReAuth, IcdCodeTypeData } from "../services/ICD";
import { configUrl } from "../constants/Config";
import { IcdCodeForReAuthPayload } from "../models/Patient";

export const getDiseaseTypeCall: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DiseaseTypeDispatchTypes
  >
> = (diseaseIdentifier: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DiseaseTypeActionDispatchTypes.DISEASE_TYPE_INVOKE,
    });
    const response = await diseaseTypeRespValues(configUrl, diseaseIdentifier);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: DiseaseTypeActionDispatchTypes.DISEASE_TYPE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: DiseaseTypeActionDispatchTypes.DISEASE_TYPE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getIcdCodeTypeData: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    IcdCodeTypeDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: IcdCodeTypeActionDispatchTypes.ICD_CODE_TYPE_INVOKE,
    });

    const response = await IcdCodeTypeData(configUrl);
    
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type:IcdCodeTypeActionDispatchTypes.ICD_CODE_TYPE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: IcdCodeTypeActionDispatchTypes.ICD_CODE_TYPE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getIcdCodeForReAuth: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReAuthIcdCodeDispatchTypes
  >
> = (payload: IcdCodeForReAuthPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReAuthIcdCodeActionDispatchTypes.RE_AUTH_ICD_CODE_INVOKE,
    });

    const response = await GetIcdCodeForReAuth(configUrl, payload);
    
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type:ReAuthIcdCodeActionDispatchTypes.RE_AUTH_ICD_CODE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: ReAuthIcdCodeActionDispatchTypes.RE_AUTH_ICD_CODE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};
